import { useApplicants } from '../../common/ApplicantsProvider';
import { RouteComponentProps, withRouter } from 'react-router';
import KeepApplicationAliveForm from './KeepApplicationAliveForm';
import {
  ChangeEventHandler,
  FormEventHandler,
  useEffect,
  useState,
} from 'react';
import { isValidEmail } from '../../../utils/validation';
import { MESSAGES, MessageType } from '../form/applicationMessages';

const KeepApplicationAlive = (props: RouteComponentProps) => {
  const isValidToken = (token: string): boolean =>
    token !== undefined && token.length === 32;
  const queryParameters = new URLSearchParams(props.location.search);
  const initialEmail = queryParameters.get('email') ?? '';
  const initialToken = queryParameters.get('token') ?? '';
  const [email, setEmail] = useState(initialEmail);
  const [token, setToken] = useState(initialToken);
  const [message, setMessage] = useState('');
  const [hasValidEmail, setValidEmail] = useState(isValidEmail(email));
  const [hasValidToken, setValidToken] = useState(isValidToken(token));
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    setValidEmail(isValidEmail(email));
  }, [email]);

  useEffect(() => {
    setValidToken(isValidToken(token));
  }, [token]);

  const onEmailChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setEmail(event.target.value);
  };

  const onTokenChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setToken(event.target.value);
  };

  const onSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    await applicantsContext
      .keepAlive(email, token)
      .then(() => setMessage(MESSAGES[MessageType.KEEP_ALIVE_SUCCESS]))
      .catch((e) => {
        if (e.type === 'BadRequestException') {
          setMessage(MESSAGES[MessageType.BAD_REQUEST]);
        } else if (e.type === 'NotFoundException') {
          setMessage(MESSAGES[MessageType.NOT_FOUND]);
        } else if (e.type === 'UnprocessableEntityException') {
          setMessage(MESSAGES[MessageType.KEEP_ALIVE_MISMATCH]);
        } else if (e.type === 'ExpiryAlreadyResetException') {
          setMessage(MESSAGES[MessageType.KEEP_ALIVE_NO_EXPIRY]);
        } else {
          setMessage(MESSAGES[MessageType.FAIL]);
        }
      });
    setSubmitting(false);
  };

  const applicantsContext = useApplicants();

  const isDisabled = !hasValidEmail || !hasValidToken || isSubmitting;

  return (
    <div className="container my-5">
      <div className="row">
        <div className="application-keep-alive">
          <KeepApplicationAliveForm
            email={email}
            hasValidEmail={hasValidEmail}
            onEmailChange={onEmailChange}
            token={token}
            hasValidToken={hasValidToken}
            onTokenChange={onTokenChange}
            onSubmit={onSubmit}
            message={message}
            isDisabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export const KeepApplicationAliveContainer = withRouter(KeepApplicationAlive);
